<script>
export default {
    props:   ['min', 'max', 'value'],
    name:    'delta-range-slider',
    data:    function () {
        return {
            hold:      false,
            percent:   0,
            lineStart: 0,
            lineEnd:   0,
        }
    },
    methods: {
        onMouseDown() {
            this.hold = true
            document.addEventListener('mousemove', this.onMouseMove)
            document.addEventListener('touchmove', this.onTouchMove)
            document.addEventListener('mouseup', this.onMouseUp)
            document.addEventListener('touchend', this.onMouseUp)
        },
        onMouseUp() {
            this.hold = false
            document.removeEventListener('mousemove', this.onMouseMove)
            document.removeEventListener('touchmove', this.onTouchMove)
            document.removeEventListener('mouseup', this.onMouseUp)
            document.removeEventListener('touchend', this.onMouseUp)
        },
        onTouchMove(event) {
            this.onMove(event.touches[0].clientX)
        },
        onMouseMove(event) {
            this.onMove(event.clientX)
        },
        onMove(clientX) {
            this.percent = 100 * (clientX - this.lineStart) / (this.lineEnd - this.lineStart)

            this.percent = Math.min(100, this.percent)
            this.percent = Math.max(0, this.percent)
        },
        onResize() {
            let lineBounding = this.$refs.line.getBoundingClientRect()

            this.lineStart = lineBounding.x
            this.lineEnd   = lineBounding.x + lineBounding.width
        },
    },
    watch:   {
        percent() {
            this.$emit('input', Math.floor((Number(this.max) - Number(this.min)) * this.percent / 100 + Number(this.min)))
        },
    },
    mounted() {
        this.percent = ((this.value - Number(this.min)) / (Number(this.max) - this.min) * 100)

        this.onResize()
        window.addEventListener('resize', this.onResize)
        this.$refs.end.addEventListener('mousedown', this.onMouseDown)
        this.$refs.end.addEventListener('touchstart', this.onMouseDown)
    },
}
</script>

<template>
    <div class="line" ref="line">
        <div class="track" :style="{'width': percent + '%'}">
            <div class="start"></div>
            <div class="end" ref="end"></div>
        </div>
    </div>
</template>

<style scoped>
.line {
    position: relative;
    width: 100%;
    background-color: rgba(141, 141, 141, .3);
    height: 2px;
}

.track {
    position: absolute;
    inset: 0 auto 0 0;
    background-color: var(--color-green);
    min-width: 0;
    max-width: 100%;
}

.start,
.end {
    width: 10px;
    height: 10px;
    position: absolute;
    touch-action: none;
    border: 2px solid var(--color-green);
    background-color: white;
    border-radius: 50%;
    top: -4px;

    &::after {
        position: relative;
        display: block;
        left: -22px;
        top: -22px;
        width: 50px;
        height: 50px;
        content: '';
    }
}

.start {
    left: -5px;
}

.end {
    right: -5px;
    cursor: pointer;
}

</style>
